import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ParametersService } from '../services/parameters.service';

@Injectable({
  providedIn: 'root'
})
export class QueueGuardGuard implements CanActivate, CanActivateChild {

  constructor(private parameterService: ParametersService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.parameterService.isFirstLoad() === true) {
        return true;
      } else {
        return this.parameterService.loadDefaultParams.pipe(map(res => {
          return true
        }))
      }
  }
  
  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.parameterService.isFirstLoad() === true) {
        return true;
      } else {
        return this.parameterService.loadDefaultParams.pipe(map(res => {
          return true
        }))
      }
  }

}
